import { Injectable, inject } from '@angular/core';

import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { ContactService } from './contact.service';
import { SfLocalizeService } from '@app/sf-lib/public_api';
import { Observable } from 'rxjs';
import { SomForm } from '@app/core/models/form.model';


@Injectable({
  providedIn: 'root'
})
export class ContactFromResolver  {
  private readonly contactService = inject(ContactService);
  private readonly router = inject(Router);
  private readonly localize = inject(SfLocalizeService);

  public resolve(route: ActivatedRouteSnapshot): Observable<SomForm> {
    if (route.url && route.url[0]) {
      return this.contactService.findForm(route.url[0].path);
    }

    // Finally redirect to contact page if the form is not found
    this.router.navigate([this.localize.instant('/contact')]);
    return null;
  }
}
